import { useBoolean } from 'usehooks-ts';
import { useState, useCallback, createContext } from 'react';

type TFrom = 'feedback' | null;

type TNotifyOverflowContextProvider = { children: React.ReactNode };
type TNotifyOverflowContext = { notify: (from?: TFrom) => void; from: TFrom };

const NotifyOverflowContext = createContext<TNotifyOverflowContext | undefined>(undefined);

const NotifyOverflowProvider = ({ children }: TNotifyOverflowContextProvider) => {
  const { value, setValue } = useBoolean(false);
  const [from, setFrom] = useState<TFrom>(null);

  const notify = useCallback(
    (_from?: TFrom) => {
      setValue(!value);
      setFrom(_from || null);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [value]
  );

  return (
     
    <NotifyOverflowContext.Provider value={{ from, notify }}>
      {children}
    </NotifyOverflowContext.Provider>
  );
};

export { NotifyOverflowContext, NotifyOverflowProvider };
